export const ON_BOARDING_FIRM_LINK = 'https://lamadash.fr/onboarding-cabinet'

export const contextMenu = [
  {
    title: 'Employeur',
    value: 'firm',
    links: [
      {
        title: 'Référencer mon cabinet',
        shortTitle: 'Référencer mon cabinet',
        link: ON_BOARDING_FIRM_LINK,
        isExternal: true,
        isFolder: false,
      },
      {
        title: 'Déposer une offre d\'emploi',
        shortTitle: 'Offre d\'emploi',
        link: ON_BOARDING_FIRM_LINK,
        isExternal: true,
        isFolder: false,
      },
      {
        title: 'Produits',
        shortTitle: 'Produits',
        isFolder: true,
        links: [
          {
            title: 'Plateforme d\'emploi',
            shortTitle: 'Plateforme d\'emploi',
            link: '/je-suis-un-cabinet#platforme-emploi',
            isExternal: false,
            isFolder: false,
          },
          {
            title: 'Créer mon site carrière',
            shortTitle: 'Site carrière',
            link: '/produits/site-carriere',
            isExternal: false,
            isFolder: false,
          },
          {
            title: 'Baromètre de la satisfaction interne',
            shortTitle: 'Baromètre eNPS',
            link: '/emploi/barometre-de-lepanouissement-en-cabinet-comptable',
            isExternal: false,
            isFolder: false,
          },
        ]
      },
    ]
  },
  {
    title: 'Candidat',
    value: 'candidate',
    links: [
      {
        title: 'Offres d\'emploi',
        shortTitle: 'Emploi',
        link: '/offres',
        isExternal: false,
        isFolder: false,
      },
      {
        title: 'Cabinets',
        shortTitle: 'Cabinets',
        link: '/cabinets',
        isExternal: false,
        isFolder: false,
      },
      {
        title: 'Déposer mon CV',
        shortTitle: 'CV',
        link: 'https://lamadash.fr/signup_login_candidat',
        isExternal: true,
        isFolder: false,
      }
    ]
  }
]
